import React, { useEffect, useState } from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import {
  Label,
  Input,
  Button,
  FormGroup,
  Row,
  Col,
} from "reactstrap";

import { Typography } from "@material-ui/core";

import { useLocation } from "react-router-dom";

import "../../../../_assets/css/whatsapp.css";
import { postMethod } from "../../../../_services/_postMethod";


// =========================================================
// QUERY
// =========================================================

function useQuery() {
  return new URLSearchParams(useLocation().search);
}


// =========================================================
// COMPONENT
// =========================================================

const BranchWhatsAppTemplate = () => {

  const queryParams = useQuery();

  const encodedBranchId = queryParams.get("id");


  // =======================================================
  // BRANCH ID
  // =======================================================

  let branchId = 0;

  try {

    branchId = encodedBranchId
      ? Number(window.atob(encodedBranchId))
      : Number(localStorage.getItem("jwl_branch_id"));

  } catch (error) {

    console.error(
      "Invalid branch id:",
      error
    );

    branchId = Number(
      localStorage.getItem("jwl_branch_id")
    );

  }


  // =======================================================
  // COMMON GREETING
  // =======================================================

  const [greet, setGreet] = useState("customer");


  // =======================================================
  // TEMPLATE TYPES
  // =======================================================

  const templateTypes = [

    {
      value: "Welcome",
      label: "Welcome",
      icon: "👋",
    },

    {
      value: "Birthday",
      label: "Birthday",
      icon: "🎂",
    },

    {
      value: "Anniversary",
      label: "Anniversary",
      icon: "💍",
    },

    {
      value: "Reference",
      label: "Reference",
      icon: "🔗",
    },

    {
      value: "Upload Design",
      label: "Upload Design",
      icon: "🎨",
    },

    {
      value: "Thank You",
      label: "Thank You",
      icon: "🙏",
    },

    {
      value: "Rate Us",
      label: "Rate Us",
      icon: "⭐",
    },

    {
      value: "General",
      label: "General",
      icon: "💬",
    },

    {
      value: "Try At Home",
      label: "Try At Home",
      icon: "🏠",
    },

    {
      value: "Business Catalogue",
      label: "Business Catalogue",
      icon: "📖",
    },

    {
      value: "Customised Catalogue",
      label: "Customised Catalogue",
      icon: "📚",
    },

    {
      value: "Referral Third Party",
      label: "Referral Third Party",
      icon: "🤝",
    },

    {
      value: "Video Call Request",
      label: "Video Call Request",
      icon: "📹",
    },

    {
      value: "Upload Voucher",
      label: "Upload Voucher",
      icon: "🎟️",
    },

    {
      value: "First Time Voucher",
      label: "First Time Voucher",
      icon: "🎁",
    },

    {
      value: "Birthday Voucher",
      label: "Birthday Voucher",
      icon: "🎂",
    },

    {
      value: "Anniversary Voucher",
      label: "Anniversary Voucher",
      icon: "💝",
    },

    {
      value: "Referral Voucher",
      label: "Referral Voucher",
      icon: "🎫",
    },

    {
      value: "Upload Design Voucher",
      label: "Upload Design Voucher",
      icon: "🖼️",
    },

    {
      value: "Others Voucher",
      label: "Others Voucher",
      icon: "🎟️",
    },

    {
      value: "Bulk WhatsApp",
      label: "Bulk WhatsApp",
      icon: "📢",
    },

    {
      value: "Add Sale",
      label: "Add Sale",
      icon: "🛒",
    },

    {
      value: "Miss Call",
      label: "Miss Call",
      icon: "📞",
    },

    {
      value: "Video Call",
      label: "Video Call",
      icon: "📹",
    },

    {
      value: "Redeem",
      label: "Redeem",
      icon: "🎁",
    },

    {
      value: "Stock Transfer",
      label: "Stock Transfer",
      icon: "🔄",
    },

    {
      value: "Stock Transfer2",
      label: "Stock Transfer2",
      icon: "🔁",
    },

    {
      value: "Stock Acceptance",
      label: "Stock Acceptance",
      icon: "📦",
    },

    {
      value: "Stock Acceptance2",
      label: "Stock Acceptance2",
      icon: "✅",
    },

    {
      value: "Earn Point",
      label: "Earn Point",
      icon: "🏆",
    },

    {
      value: "Redeem Point",
      label: "Redeem Point",
      icon: "🎯",
    },

    {
      value: "Point Remainder",
      label: "Point Remainder",
      icon: "🔔",
    },

    {
      value: "Appointment Owner",
      label: "Appointment Owner",
      icon: "👤",
    },

    {
      value: "Appointment Customer",
      label: "Appointment Customer",
      icon: "👥",
    },

    {
      value: "Service Remainder",
      label: "Service Remainder",
      icon: "🔔",
    },

    {
      value: "Service Due",
      label: "Service Due",
      icon: "⏰",
    },

    {
      value: "Service Done",
      label: "Service Done",
      icon: "✅",
    },

  ];


  // =======================================================
  // TEMPLATE TYPE HELPER
  // =======================================================

  const getTemplateTypeDetails = (
    type
  ) => {

    const found =
      templateTypes.find(
        (item) =>
          String(item.value).toLowerCase() ===
          String(type || "").toLowerCase()
      );

    return (
      found || {
        value: type || "",
        label: type || "General",
        icon: "💬",
      }
    );

  };


  // =======================================================
  // TEMPLATE LIST
  // =======================================================

  const [templates, setTemplates] = useState([]);


  // =======================================================
  // CHOOSE TEMPLATE
  // =======================================================

  const [showTemplateTypes, setShowTemplateTypes] =
    useState(false);


  // =======================================================
  // FORM
  // =======================================================

  const [showForm, setShowForm] = useState(false);

  const [editingId, setEditingId] = useState(null);

  const [templateId, setTemplateId] = useState("");

  const [templateName, setTemplateName] = useState("");

  const [templateText, setTemplateText] = useState("");

  const [templateType, setTemplateType] = useState("");


  // =======================================================
  // LOADING
  // =======================================================

  const [loading, setLoading] = useState(false);

  const [deleteLoading, setDeleteLoading] = useState(false);

  const [greetingLoading, setGreetingLoading] = useState(false);


  // =========================================================
  // NORMALIZE API RESPONSE
  // =========================================================

  const extractTemplateData = (response) => {

    console.log(
      "RAW TEMPLATE API RESPONSE:",
      response
    );


    const possibleData = [

      response?.data?.data,

      response?.data?.result,

      response?.data?.templates,

      response?.data,

      response?.result,

      response?.templates,

      response,

    ];


    for (
      let i = 0;
      i < possibleData.length;
      i++
    ) {

      if (
        Array.isArray(
          possibleData[i]
        )
      ) {

        return possibleData[i];

      }

    }


    for (
      let i = 0;
      i < possibleData.length;
      i++
    ) {

      const value =
        possibleData[i];


      if (
        value &&
        typeof value === "object" &&
        !Array.isArray(value)
      ) {

        const objectKeys =
          Object.keys(value);


        for (
          let j = 0;
          j < objectKeys.length;
          j++
        ) {

          const key =
            objectKeys[j];


          if (
            Array.isArray(
              value[key]
            )
          ) {

            return value[key];

          }

        }

      }

    }


    return [];

  };


  // =========================================================
  // GENERATE NEXT TEMPLATE ID
  // =========================================================

  const generateTemplateId = (
    templateList = []
  ) => {

    const validTemplates =
      Array.isArray(templateList)
        ? templateList.filter(
            (item) =>
              item &&
              item.template_id
          )
        : [];


    if (
      validTemplates.length === 0
    ) {

      return `WA-${branchId}-0001`;

    }


    let maxNumber = 0;


    validTemplates.forEach(
      (item) => {

        const currentId =
          String(
            item.template_id || ""
          );


        const parts =
          currentId.split("-");


        const lastPart =
          parts[
            parts.length - 1
          ];


        const number =
          parseInt(
            lastPart,
            10
          );


        if (
          !isNaN(number) &&
          number > maxNumber
        ) {

          maxNumber = number;

        }

      }
    );


    const nextNumber =
      maxNumber + 1;


    const nextTemplateId =
      `WA-${branchId}-${String(
        nextNumber
      ).padStart(4, "0")}`;


    console.log(
      "Generated Next Template ID:",
      nextTemplateId
    );


    return nextTemplateId;

  };


  // =========================================================
  // LOAD TEMPLATES
  // =========================================================

  const loadTemplates = async () => {

    if (!branchId) {

      console.error(
        "Branch ID is missing."
      );

      setTemplates([]);

      return [];

    }


    try {

      setLoading(true);


      console.log(
        "Loading templates for branch:",
        branchId
      );


      const response =
        await postMethod(
          "api/masters/branch-whatsapp-template/browse",
          {
            branch_id: branchId,
          }
        );


      console.log(
        "BROWSE TEMPLATE RESPONSE:",
        response
      );


      const templateData =
        extractTemplateData(
          response
        );


      console.log(
        "EXTRACTED TEMPLATE DATA:",
        templateData
      );


      if (
        Array.isArray(templateData)
      ) {

        setTemplates(
          templateData
        );

      } else {

        setTemplates([]);

      }


      // =====================================================
      // COMMON GREETING
      // =====================================================

      if (
        Array.isArray(templateData) &&
        templateData.length > 0
      ) {

        const firstTemplate =
          templateData.find(
            (item) =>
              item &&
              item.greet
          );


        if (
          firstTemplate?.greet
        ) {

          setGreet(
            firstTemplate.greet
          );

        }

      }


      return Array.isArray(
        templateData
      )
        ? templateData
        : [];


    } catch (error) {

      console.error(
        "browse_branch_whatsapp_template:",
        error
      );


      setTemplates([]);

      return [];


    } finally {

      setLoading(false);

    }

  };


  // =========================================================
  // LOAD ON COMPONENT OPEN / BRANCH CHANGE
  // =========================================================

  useEffect(() => {

    if (branchId) {

      loadTemplates();

    } else {

      setTemplates([]);

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId]);


  // =========================================================
  // GREETING CHANGE
  // =========================================================

  const handleGreetingChange = async (
    value
  ) => {

    setGreet(value);


    if (
      !Array.isArray(templates) ||
      templates.length === 0
    ) {

      return;

    }


    try {

      setGreetingLoading(true);


      for (
        const item of templates
      ) {

        const payload = {

          whatsapp_template_id:
            item.whatsapp_template_id,

          template_id:
            item.template_id,

          branch_id:
            item.branch_id ||
            branchId,

          greet:
            value,

          template_name:
            item.template_name,

          template:
            item.template,

          // ===============================================
          // TEMPLATE TYPE
          // ===============================================

          template_type:
            item.template_type || "",

        };


        console.log(
          "UPDATING GREETING PAYLOAD:",
          payload
        );


        const response =
          await postMethod(
            "api/masters/branch-whatsapp-template/save",
            payload
          );


        console.log(
          "GREETING UPDATE RESPONSE:",
          response
        );

      }


      setTemplates(
        (previousTemplates) =>
          previousTemplates.map(
            (item) => ({
              ...item,
              greet: value,
            })
          )
      );


      console.log(
        "Common greeting updated:",
        value
      );


    } catch (error) {

      console.error(
        "update_common_greeting:",
        error
      );


      alert(
        "Greeting update failed."
      );


      await loadTemplates();


    } finally {

      setGreetingLoading(false);

    }

  };


  // =========================================================
  // CHOOSE TEMPLATE TYPE
  // =========================================================

  const handleChooseTemplateType = (
    selectedType
  ) => {

    setEditingId(null);

    setTemplateType(
      selectedType
    );

    setTemplateName("");

    setTemplateText("");


    const nextTemplateId =
      generateTemplateId(
        templates
      );


    setTemplateId(
      nextTemplateId
    );


    setShowTemplateTypes(false);

    setShowForm(true);

  };


  // =========================================================
  // OPEN CHOOSE TEMPLATE
  // =========================================================

  const openChooseTemplate = () => {

    setShowTemplateTypes(
      !showTemplateTypes
    );

    if (showForm) {

      closeForm();

    }

  };


  // =========================================================
  // CLOSE FORM
  // =========================================================

  const closeForm = () => {

    setShowForm(false);

    setEditingId(null);

    setTemplateId("");

    setTemplateName("");

    setTemplateText("");

    setTemplateType("");

  };


  // =========================================================
  // SAVE TEMPLATE
  // =========================================================

  const handleSaveTemplate =
    async () => {

      // ===================================================
      // VALIDATION
      // ===================================================

      if (
        !templateType
      ) {

        alert(
          "Please choose template type."
        );

        return;

      }


      if (
        !templateName.trim()
      ) {

        alert(
          "Please enter template name."
        );

        return;

      }


      if (
        !templateText.trim()
      ) {

        alert(
          "Please enter template message."
        );

        return;

      }


      if (!branchId) {

        alert(
          "Branch ID is missing."
        );

        return;

      }


      // ===================================================
      // TEMPLATE ID
      // ===================================================

      let saveTemplateId =
        templateId;


      if (!editingId) {

        if (
          !saveTemplateId
        ) {

          saveTemplateId =
            generateTemplateId(
              templates
            );

        }

      }


      // ===================================================
      // PAYLOAD
      // ===================================================

      const payload = {

        whatsapp_template_id:
          editingId || 0,

        template_id:
          saveTemplateId,

        branch_id:
          branchId,

        greet:
          greet,

        template_name:
          templateName.trim(),

        template:
          templateText.trim(),

        // ===============================================
        // NEW FIELD
        // ===============================================

        template_type:
          templateType,

      };


      console.log(
        "SAVE TEMPLATE PAYLOAD:",
        payload
      );


      try {

        setLoading(true);


        const response =
          await postMethod(
            "api/masters/branch-whatsapp-template/save",
            payload
          );


        console.log(
          "SAVE TEMPLATE RESPONSE:",
          response
        );


        const status =
          Number(
            response?.data?.status
          ) ||
          Number(
            response?.status
          );


        // =================================================
        // SUCCESS
        // =================================================

        if (
          status === 200
        ) {

          const freshTemplates =
            await loadTemplates();


          console.log(
            "Fresh templates after save:",
            freshTemplates
          );


          // ===============================================
          // EDIT
          // ===============================================

          if (
            editingId
          ) {

            closeForm();


            alert(
              "Template updated successfully."
            );


            return;

          }


          // ===============================================
          // ADD
          // ===============================================

          setEditingId(null);

          setTemplateName("");

          setTemplateText("");

          setTemplateType("");


          const nextTemplateId =
            generateTemplateId(
              freshTemplates
            );


          setTemplateId(
            nextTemplateId
          );


          setShowForm(false);

          setShowTemplateTypes(false);


          alert(
            "Template added successfully."
          );


          return;

        }


        // =================================================
        // ERROR
        // =================================================

        alert(
          response?.data?.error ||
          response?.data?.message ||
          response?.error ||
          response?.message ||
          "Something went wrong while saving template."
        );


      } catch (error) {

        console.error(
          "save_branch_whatsapp_template:",
          error
        );


        alert(
          "Something went wrong while saving template."
        );


      } finally {

        setLoading(false);

      }

    };


  // =========================================================
  // EDIT TEMPLATE
  // =========================================================

  const handleEditTemplate = (
    item
  ) => {

    console.log(
      "Edit Template:",
      item
    );


    setEditingId(
      item.whatsapp_template_id
    );


    setTemplateId(
      item.template_id || ""
    );


    setTemplateName(
      item.template_name || ""
    );


    setTemplateText(
      item.template || ""
    );


    // =====================================================
    // TEMPLATE TYPE
    // =====================================================

    setTemplateType(
      item.template_type || ""
    );


    // =====================================================
    // EXISTING GREETING
    // =====================================================

    setGreet(
      item.greet ||
      greet ||
      "customer"
    );


    setShowTemplateTypes(false);

    setShowForm(true);

  };


  // =========================================================
  // DELETE TEMPLATE
  // =========================================================

  const handleDeleteTemplate =
    async (
      whatsappTemplateId
    ) => {

      const confirmDelete =
        window.confirm(
          "Are you sure you want to delete this template?"
        );


      if (!confirmDelete) {

        return;

      }


      try {

        setDeleteLoading(true);


        const response =
          await postMethod(
            "api/masters/branch-whatsapp-template/delete",
            {
              whatsapp_template_id:
                whatsappTemplateId,
            }
          );


        console.log(
          "DELETE TEMPLATE RESPONSE:",
          response
        );


        const status =
          Number(
            response?.data?.status
          ) ||
          Number(
            response?.status
          );


        if (
          status === 200
        ) {

          const freshTemplates =
            await loadTemplates();


          if (
            showForm &&
            !editingId
          ) {

            const nextTemplateId =
              generateTemplateId(
                freshTemplates
              );


            setTemplateId(
              nextTemplateId
            );

          }


          if (
            editingId ===
            whatsappTemplateId
          ) {

            closeForm();

          }


          alert(
            "Template deleted successfully."
          );


        } else {

          alert(
            response?.data?.error ||
            response?.data?.message ||
            response?.error ||
            response?.message ||
            "Unable to delete template."
          );

        }


      } catch (error) {

        console.error(
          "delete_branch_whatsapp_template:",
          error
        );


        alert(
          "Something went wrong while deleting template."
        );


      } finally {

        setDeleteLoading(false);

      }

    };


  // =========================================================
  // GREETING TEXT
  // =========================================================

  const getGreetingText = () => {

    switch (greet) {

      case "member":
        return "Dear Member";

      case "customer_name":
        return "Dear Customer Name";

      case "customer":
      default:
        return "Dear Customer";

    }

  };


  // =========================================================
  // TEMPLATE MESSAGE PREVIEW
  // =========================================================

  const renderTemplateMessage = (
    text
  ) => {

    if (!text) {

      return null;

    }


    const parts =
      String(text).split(
        /(\$[^$]+\$)/g
      );


    return parts.map(
      (part, index) => {

        if (
          part.startsWith("$") &&
          part.endsWith("$")
        ) {

          return (
            <span
              key={index}
              className="variable-text"
            >
              {part}
            </span>
          );

        }


        return (
          <React.Fragment
            key={index}
          >
            {part}
          </React.Fragment>
        );

      }
    );

  };


  // =========================================================
  // RENDER
  // =========================================================

  return (

    <div className="whatsapp-template-page">


      {/* ================================================= */}
      {/* HEADER */}
      {/* ================================================= */}

      <Card className="template-header-card">

        <CardContent>

          <div className="template-header">

            <div className="header-left">

              <div className="header-icon">
                💬
              </div>


              <div>

                <Typography
                  variant="h5"
                  className="template-title"
                >
                  WhatsApp Templates
                </Typography>


                <div className="template-subtitle">

                  Manage WhatsApp message
                  templates for your branch

                </div>

              </div>

            </div>


            <Button
              color="primary"
              className="add-template-btn"
              onClick={
                openChooseTemplate
              }
              disabled={
                loading ||
                deleteLoading ||
                greetingLoading
              }
            >

              {showTemplateTypes
                ? "Close"
                : "Choose Template"}

            </Button>

          </div>

        </CardContent>

      </Card>


      {/* ================================================= */}
      {/* CHOOSE TEMPLATE TYPE */}
      {/* ================================================= */}

      {showTemplateTypes && (

        <Card className="template-form-card">

          <CardContent>

            <div className="form-heading">

              <div className="form-icon">
                📋
              </div>


              <div>

                <Typography variant="h6">

                  Choose Template

                </Typography>


                <span>

                  Select the type of WhatsApp
                  template you want to create.

                </span>

              </div>

            </div>


            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fill, minmax(180px, 1fr))",
                gap: "12px",
                marginTop: "20px",
              }}
            >

              {templateTypes.map(
                (type) => (

                  <button
                    key={type.value}
                    type="button"
                    onClick={() =>
                      handleChooseTemplateType(
                        type.value
                      )
                    }
                    disabled={
                      loading ||
                      greetingLoading ||
                      deleteLoading
                    }
                    style={{
                      border:
                        "1px solid #e0e0e0",
                      background:
                        "#fff",
                      borderRadius:
                        "10px",
                      padding:
                        "14px 12px",
                      cursor:
                        "pointer",
                      display:
                        "flex",
                      alignItems:
                        "center",
                      gap:
                        "10px",
                      textAlign:
                        "left",
                      transition:
                        "all 0.2s ease",
                    }}
                  >

                    <span
                      style={{
                        fontSize:
                          "24px",
                        width:
                          "32px",
                        textAlign:
                          "center",
                      }}
                    >
                      {type.icon}
                    </span>


                    <span
                      style={{
                        fontSize:
                          "14px",
                        fontWeight:
                          600,
                        color:
                          "#333",
                      }}
                    >
                      {type.label}
                    </span>

                  </button>

                )
              )}

            </div>

          </CardContent>

        </Card>

      )}


      {/* ================================================= */}
      {/* COMMON GREETING */}
      {/* ================================================= */}

      <Card className="common-greeting-card">

        <CardContent>

          <div className="section-title">

            <div className="section-icon">
              👋
            </div>


            <div>

              <Typography variant="h6">

                Customer Greeting

              </Typography>


              <div className="section-description">

                Select one greeting.
                This greeting will be common
                for all WhatsApp templates.

              </div>

            </div>

          </div>


          <div className="greeting-options">


            {/* ================================================= */}
            {/* MEMBER */}
            {/* ================================================= */}

            <label
              className={`greeting-option ${
                greet === "member"
                  ? "selected"
                  : ""
              }`}
            >

              <Input
                type="radio"
                name="customerGreeting"
                checked={
                  greet === "member"
                }
                disabled={
                  greetingLoading ||
                  loading
                }
                onChange={() =>
                  handleGreetingChange(
                    "member"
                  )
                }
              />


              <div className="greeting-content">

                <strong>
                  Dear Member
                </strong>

                <span>
                  Formal greeting for members
                </span>

              </div>

            </label>


            {/* ================================================= */}
            {/* CUSTOMER */}
            {/* ================================================= */}

            <label
              className={`greeting-option ${
                greet === "customer"
                  ? "selected"
                  : ""
              }`}
            >

              <Input
                type="radio"
                name="customerGreeting"
                checked={
                  greet === "customer"
                }
                disabled={
                  greetingLoading ||
                  loading
                }
                onChange={() =>
                  handleGreetingChange(
                    "customer"
                  )
                }
              />


              <div className="greeting-content">

                <strong>
                  Dear Customer
                </strong>

                <span>
                  Standard customer greeting
                </span>

              </div>

            </label>


            {/* ================================================= */}
            {/* CUSTOMER NAME */}
            {/* ================================================= */}

            <label
              className={`greeting-option ${
                greet === "customer_name"
                  ? "selected"
                  : ""
              }`}
            >

              <Input
                type="radio"
                name="customerGreeting"
                checked={
                  greet === "customer_name"
                }
                disabled={
                  greetingLoading ||
                  loading
                }
                onChange={() =>
                  handleGreetingChange(
                    "customer_name"
                  )
                }
              />


              <div className="greeting-content">

                <strong>
                  Dear Customer Name
                </strong>

                <span>
                  Personalized customer greeting
                </span>

              </div>

            </label>

          </div>


          <div className="common-setting-note">

            <span>
              ℹ️
            </span>

            <span>

              {greetingLoading
                ? "Updating common greeting..."
                : "This greeting is common for all templates created under this branch."}

            </span>

          </div>

        </CardContent>

      </Card>


      {/* ================================================= */}
      {/* TEMPLATE FORM */}
      {/* ================================================= */}

      {showForm && (

        <Card className="template-form-card">

          <CardContent>


            <div className="form-heading">

              <div className="form-icon">

                {editingId
                  ? "✏️"
                  : "➕"}

              </div>


              <div>

                <Typography variant="h6">

                  {editingId
                    ? "Edit WhatsApp Template"
                    : "Add WhatsApp Template"}

                </Typography>


                <span>

                  Create a personalized WhatsApp
                  message for your customers.

                </span>

              </div>

            </div>


            {/* ================================================= */}
            {/* SELECTED TEMPLATE TYPE */}
            {/* ================================================= */}

            <FormGroup>

              <Label className="form-label">

                Template Type

              </Label>


              <div
                style={{
                  display:
                    "flex",
                  alignItems:
                    "center",
                  justifyContent:
                    "space-between",
                  border:
                    "1px solid #ddd",
                  borderRadius:
                    "6px",
                  padding:
                    "10px 12px",
                  background:
                    "#f8f9fa",
                }}
              >

                <div
                  style={{
                    display:
                      "flex",
                    alignItems:
                      "center",
                    gap:
                      "10px",
                  }}
                >

                  <span
                    style={{
                      fontSize:
                        "22px",
                    }}
                  >
                    {
                      getTemplateTypeDetails(
                        templateType
                      ).icon
                    }
                  </span>


                  <strong>

                    {
                      getTemplateTypeDetails(
                        templateType
                      ).label ||
                      "No Template Type"
                    }

                  </strong>

                </div>


                {!editingId && (

                  <Button
                    type="button"
                    color="primary"
                    size="sm"
                    outline
                    onClick={() => {

                      setShowForm(false);

                      setShowTemplateTypes(
                        true
                      );

                    }}
                    disabled={
                      loading ||
                      greetingLoading
                    }
                  >

                    Change

                  </Button>

                )}

              </div>

            </FormGroup>


            <Row>


              <Col md="6">

                <FormGroup>

                  <Label className="form-label">

                    Template Name

                  </Label>


                  <Input
                    type="text"
                    value={
                      templateName
                    }
                    onChange={(e) =>
                      setTemplateName(
                        e.target.value
                      )
                    }
                    placeholder="e.g. Birthday Greeting"
                    className="custom-input"
                    disabled={
                      loading ||
                      greetingLoading
                    }
                  />

                </FormGroup>

              </Col>


              {/* ================================================= */}
              {/* TEMPLATE ID */}
              {/* ================================================= */}

              <Col md="6">

                <FormGroup>

                  <Label className="form-label">

                    Template ID

                  </Label>


                  <Input
                    type="text"
                    value={
                      templateId
                    }
                    disabled
                    className="custom-input template-id-input"
                  />

                </FormGroup>

              </Col>

            </Row>


            {/* ================================================= */}
            {/* TEMPLATE MESSAGE */}
            {/* ================================================= */}

            <FormGroup>

              <Label className="form-label">

                Template Message

              </Label>


              <div className="message-editor">

                <textarea
                  id="whatsapp-template-textarea"
                  value={
                    templateText
                  }
                  onChange={(e) =>
                    setTemplateText(
                      e.target.value
                    )
                  }
                  className="template-textarea"
                  placeholder="Type your WhatsApp message..."
                  disabled={
                    loading ||
                    greetingLoading
                  }
                />


                <div className="variable-info">

                  <span>

                    Write{" "}

                    <strong>
                      $variable$
                    </strong>{" "}

                    in the message.

                    It will be replaced with
                    the actual value when the
                    message is sent.

                  </span>

                </div>

              </div>

            </FormGroup>


            {/* ================================================= */}
            {/* LIVE PREVIEW */}
            {/* ================================================= */}

            <div className="live-preview">

              <div className="preview-title">

                Message Preview

              </div>


              <div className="whatsapp-preview">

                <div className="preview-message">

                  <strong>

                    {getGreetingText()},

                  </strong>


                  <div className="preview-text">

                    {renderTemplateMessage(
                      templateText
                    )}

                  </div>

                </div>

              </div>

            </div>


            {/* ================================================= */}
            {/* FORM ACTIONS */}
            {/* ================================================= */}

            <div className="form-actions">

              <Button
                type="button"
                color="secondary"
                outline
                onClick={
                  closeForm
                }
                disabled={
                  loading ||
                  greetingLoading
                }
              >

                Cancel

              </Button>


              <Button
                type="button"
                color="primary"
                className="save-template-btn"
                disabled={
                  loading ||
                  deleteLoading ||
                  greetingLoading
                }
                onClick={
                  handleSaveTemplate
                }
              >

                {loading
                  ? "Saving..."
                  : editingId
                  ? "Update Template"
                  : "+ Add Template"}

              </Button>

            </div>

          </CardContent>

        </Card>

      )}


      {/* ================================================= */}
      {/* TEMPLATE LIST */}
      {/* ================================================= */}

      <div className="template-list">


        <div className="list-heading">

          <div>

            <Typography variant="h6">

              Templates

            </Typography>


            <span>

              {templates.length} template
              {templates.length !== 1
                ? "s"
                : ""}{" "}
              added

            </span>

          </div>

        </div>


        {/* ================================================= */}
        {/* LOADING */}
        {/* ================================================= */}

        {loading &&
        templates.length === 0 &&
        !showForm ? (

          <Card className="empty-template-card">

            <CardContent>

              <div className="empty-icon">
                ⏳
              </div>


              <Typography variant="h6">

                Loading Templates...

              </Typography>


              <span>

                Please wait while templates
                are being loaded.

              </span>

            </CardContent>

          </Card>


        ) : templates.length === 0 ? (

          /* ================================================= */
          /* EMPTY */
          /* ================================================= */

          <Card className="empty-template-card">

            <CardContent>

              <div className="empty-icon">
                💬
              </div>


              <Typography variant="h6">

                No Templates Added

              </Typography>


              <span>

                Choose your first WhatsApp
                template using the button above.

              </span>

            </CardContent>

          </Card>


        ) : (

          /* ================================================= */
          /* TEMPLATE LIST */
          /* ================================================= */

          templates.map(
            (item, index) => {

              const typeDetails =
                getTemplateTypeDetails(
                  item.template_type
                );


              return (

                <Card
                  key={
                    item.whatsapp_template_id ||
                    item.template_id ||
                    index
                  }
                  className="template-item-card"
                >

                  <CardContent>


                    {/* ========================================= */}
                    {/* TEMPLATE HEADER */}
                    {/* ========================================= */}

                    <div className="template-item-header">


                      <div className="template-name-wrapper">

                        <div className="template-small-icon">
                          💬
                        </div>


                        <div>

                          <Typography variant="h6">

                            {
                              item.template_name ||
                              "Untitled Template"
                            }

                          </Typography>


                          {/* =================================== */}
                          {/* TEMPLATE TYPE */}
                          {/* =================================== */}

                          <div
                            style={{
                              display:
                                "flex",
                              alignItems:
                                "center",
                              gap:
                                "6px",
                              marginTop:
                                "4px",
                              marginBottom:
                                "3px",
                            }}
                          >

                            <span
                              style={{
                                fontSize:
                                  "18px",
                              }}
                            >
                              {typeDetails.icon}
                            </span>


                            <strong
                              style={{
                                fontSize:
                                  "13px",
                                color:
                                  "#555",
                              }}
                            >

                              Template Type:{" "}

                              {
                                item.template_type ||
                                "-"
                              }

                            </strong>

                          </div>


                          <span className="template-id">

                            ID:{" "}

                            {
                              item.template_id ||
                              "-"
                            }

                          </span>


                          <span
                            className="template-id"
                            style={{
                              display:
                                "block",
                            }}
                          >

                            Branch ID:{" "}

                            {
                              item.branch_id ||
                              branchId
                            }

                          </span>

                        </div>

                      </div>


                      {/* ========================================= */}
                      {/* ACTIONS */}
                      {/* ========================================= */}

                      <div className="template-actions">

                        <Button
                          color="primary"
                          size="sm"
                          outline
                          onClick={() =>
                            handleEditTemplate(
                              item
                            )
                          }
                          disabled={
                            deleteLoading ||
                            loading ||
                            greetingLoading
                          }
                        >

                          Edit

                        </Button>


                        <Button
                          color="danger"
                          size="sm"
                          outline
                          onClick={() =>
                            handleDeleteTemplate(
                              item.whatsapp_template_id
                            )
                          }
                          disabled={
                            deleteLoading ||
                            loading ||
                            greetingLoading
                          }
                        >

                          {deleteLoading
                            ? "Deleting..."
                            : "Delete"}

                        </Button>

                      </div>

                    </div>


                    {/* ========================================= */}
                    {/* TEMPLATE PREVIEW */}
                    {/* ========================================= */}

                    <div className="template-content-row">

                      <div className="template-preview">


                        {/* ======================================= */}
                        {/* COMMON GREETING */}
                        {/* ======================================= */}

                        <div className="preview-greeting">

                          {
                            getGreetingText()
                          },

                        </div>


                        {/* ======================================= */}
                        {/* SAVED MESSAGE */}
                        {/* ======================================= */}

                        <div className="preview-message">

                          {
                            renderTemplateMessage(
                              item.template
                            )
                          }

                        </div>

                      </div>

                    </div>


                    {/* ========================================= */}
                    {/* FOOTER */}
                    {/* ========================================= */}

                    <div className="template-footer">

                      <span>

                        Template Type:{" "}

                        <strong>

                          {
                            typeDetails.icon
                          }{" "}

                          {
                            item.template_type ||
                            "-"
                          }

                        </strong>

                      </span>


                      <span>

                        Greeting:{" "}

                        {
                          getGreetingText()
                        }

                      </span>

                    </div>

                  </CardContent>

                </Card>

              );

            }

          )

        )}

      </div>

    </div>

  );

};


export default BranchWhatsAppTemplate;